gsap.registerPlugin(ScrollTrigger, Flip);

const loadingWrap = document.querySelector('.loading-wrap');
const loadingItems = loadingWrap ? loadingWrap.querySelectorAll('.loading__item') : [];
const fadeInItems = document.querySelectorAll('.loading__fade');

/**
 * Animates a loader element's counter text from 0 to 100 over a specified duration using an ease-out cubic function.
 *
 * @return {void} Does not return a value.
 */
function startLoader() {
    const counterElement = document.querySelector('.loader__count .count__text');
    if (!counterElement) return;

    const duration = 500;
    const start = performance.now();
    let lastValue = 0;
    counterElement.textContent = '0';

    /**
     * Applies the ease-out cubic easing function to a given input value.
     * The function generates a gradual deceleration effect, commonly used in animations.
     *
     * @param {number} t - The input time value, typically in the range [0, 1], where 0 represents the start and 1 represents the end.
     * @return {number} The eased output value corresponding to the input time value.
     */
    function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
    }

    /**
     * Updates the counter value over time using an animation frame.
     *
     * @param {number} now - The current time in milliseconds, typically provided by the requestAnimationFrame callback.
     * @return {void} This function does not return a value.
     */
    function updateCounter(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = easeOutCubic(progress);
        const value = Math.floor(eased * 100);
        if (value !== lastValue) {
            counterElement.textContent = String(value);
            lastValue = value;
        }
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        }
    }

    requestAnimationFrame(updateCounter);
}

/**
 * Hides the loading screen by animating the loader elements and updating their state.
 *
 * The function updates the text content of the loader counter to display "100",
 * animates the loader counter and wrapper elements off-screen using GSAP,
 * and then adds a 'loaded' class to the loader element.
 *
 * @return {void} This method does not return any value.
 */
function hideLoader() {
    const counterElement = document.querySelector('.loader__count .count__text');
    if (counterElement) {
        counterElement.textContent = '100';
    }

    const loader = document.getElementById('loader');
    if (!loader) return;

    const tl = gsap.timeline({
        onComplete: () => {
            loader.classList.add('loaded');
        }
    });

    tl.to('.loader__count', {
        duration: 0.45,
        ease: 'power2.in',
        y: '100%'
    }, 0.15);
    tl.to('.loader__wrapper', {
        duration: 0.55,
        ease: 'power4.in',
        y: '-100%'
    }, 0.35);
}

/**
 * Animates the appearance of page elements using GSAP.
 *
 * @return {void}
 */
function pageAppearance() {
    if (loadingItems.length) {
        gsap.set(loadingItems, {opacity: 0, y: 60});
        gsap.to(loadingItems, {
            duration: 0.7,
            ease: 'power3.out',
            y: 0,
            opacity: 1,
            delay: 0.2,
            stagger: 0.05
        });
    }
    if (fadeInItems.length) {
        gsap.set(fadeInItems, {opacity: 0});
        gsap.to(fadeInItems, {
            duration: 0.5,
            ease: 'none',
            opacity: 1,
            delay: 0.45
        });
    }
}

/**
 * Waits for a stylesheet with a specific id to load and become applied. Executes a callback when the stylesheet is ready.
 *
 * @param {string} id - The id of the link element representing the stylesheet to wait for.
 * @param {Function} callback - The function to execute once the specified stylesheet has been applied.
 * @return {void} This method does not return any value.
 */
function waitForStylesheet(id, callback) {
    const link = document.getElementById(id);

    if (!link) {
        callback();
        return;
    }
    let done = false;

    /**
     * Completes the operation if it has not already been marked as finished.
     * Sets the state to finished and triggers the provided callback.
     *
     * @return {void} Does not return a value.
     */
    function finish() {
        if (done) return;
        done = true;
        callback();
    }

    /**
     * Checks if the provided link element is ready by verifying if its `rel` attribute is set to 'stylesheet'
     * and if it has a valid `sheet` property.
     *
     * @return {boolean} True if the link element is a valid stylesheet and its sheet is accessible; otherwise, false.
     */
    function isReady() {
        return link.rel === 'stylesheet' && !!link.sheet;
    }

    if (isReady()) {
        finish();
        return;
    }

    link.addEventListener('load', () => {
        if (isReady()) {
            finish();
        }
    }, {once: true});
    requestAnimationFrame(() => {
        if (isReady()) {
            finish();
        }
    });
}

/**
 * Loader Initialization
 */
startLoader();
document.addEventListener('DOMContentLoaded', () => {
    waitForStylesheet('dmytro-koval-global-css', () => {
        document.documentElement.classList.remove('is-loading');
        hideLoader();
        pageAppearance();
    });
});
